import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default class DescriptionDialog extends React.Component {
  setEditorReference = (ref) => {
    this.editorReferece = ref;
    if (ref) {
      ref.focus();
    }
  };
  render() {
    let allowedToAddLinks = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToAddLinks = true;
    }
    const editorOptions = ["inline", "list", "emoji", "history"];
    if (allowedToAddLinks) {
      editorOptions.push("link");
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          <DialogContentText />
          <Editor
            editorRef={this.setEditorReference}
            editorState={this.props.description}
            editorStyle={{
              border: "1px solid #F1F1F1",
              borderRadius: 2,
              minHeight: 300,
            }}
            onEditorStateChange={this.props.handleDescriptionChange}
            toolbar={{
              options: editorOptions,
              inline: { options: ["bold", "italic", "underline"] },
              list: { options: ["unordered", "ordered"] },
              emoji: {
                emojis: [
                  "🏆",
                  "🥇",
                  "🥈",
                  "🥉",
                  "🏅",
                  "⚽️",
                  "🏀",
                  "🏈",
                  "⚾️",
                  "🎾",
                  "🏐",
                  "🏉",
                  "🎱",
                  "🎮",
                  "🎳",
                  "🏓",
                  "🏸",
                  "🥅",
                  "🏒",
                  "🏑",
                  "🏏",
                  "⛳️",
                  "🥊",
                  "🥋",
                  "🎽",
                  "⛸",
                  "🥌",
                  "⛹️‍♀️",
                  "⛹️‍♂️",
                  "🤾‍♀️",
                  "🤾‍♂️",
                  "🏌️‍♀️",
                  "🏊‍♀️",
                  "🏊‍♂️",
                  "🤽‍♀️",
                  "🤽‍♂️",
                  "🚴‍♀️",
                  "🚴‍♂️",
                  "😀",
                  "😁",
                  "😂",
                  "😃",
                  "😉",
                  "😋",
                  "😎",
                  "😍",
                  "😗",
                  "🤗",
                  "🤔",
                  "😣",
                  "😫",
                  "😴",
                  "😌",
                  "🤓",
                  "😛",
                  "😜",
                  "😠",
                  "😇",
                  "😷",
                  "😈",
                  "👻",
                  "😺",
                  "😸",
                  "😹",
                  "😻",
                  "😼",
                  "😽",
                  "🙀",
                  "🙈",
                  "🙉",
                  "🙊",
                  "👼",
                  "👮",
                  "🕵",
                  "💂",
                  "👳",
                  "🎅",
                  "👸",
                  "👰",
                  "👲",
                  "🙍",
                  "🙇",
                  "🚶",
                  "🏃",
                  "👫",
                  "💪",
                  "👈",
                  "👉",
                  "👉",
                  "👆",
                  "👇",
                  "🖖",
                  "🤘",
                  "🖐",
                  "👌",
                  "👍",
                  "👎",
                  "✊",
                  "👊",
                  "👏",
                  "🙌",
                  "🙏",
                  "🐵",
                  "🐶",
                  "🐇",
                  "🐥",
                  "🐸",
                  "🐌",
                  "🐛",
                  "🐜",
                  "🐝",
                  "🍉",
                  "🍄",
                  "🍔",
                  "🍤",
                  "🍨",
                  "🍪",
                  "🎂",
                  "🍰",
                  "🍾",
                  "🍷",
                  "🍸",
                  "🍺",
                  "🌍",
                  "🚑",
                  "⏰",
                  "🌙",
                  "🌝",
                  "🌞",
                  "⭐",
                  "🌟",
                  "🌠",
                  "🌨",
                  "🌩",
                  "⛄",
                  "🔥",
                  "🎄",
                  "🎈",
                  "🎉",
                  "🎊",
                  "🎁",
                  "🎗",
                  "🔇",
                  "🔈",
                  "📣",
                  "🔔",
                  "🎵",
                  "🎷",
                  "💰",
                  "🖊",
                  "📅",
                  "✅",
                  "❎",
                  "💯",
                ],
              },
            }}
          />
          {/* <TextField
              autoFocus
              multiline
              rows="8"
              fullWidth
              name="description"
              value={this.props.description.replace(/<br \/>/g, "\n")}
              onChange={this.props.handleDescriptionChange}
            /> */}
        </DialogContent>
        {this.props.errorMessage && (
          <DialogActions>
            <div>
              <Typography style={{ color: "red" }}>
                {this.props.errorMessage}
              </Typography>
            </div>
          </DialogActions>
        )}
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.general.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
